
import Card from "@/components/Card.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { computed, defineComponent, onBeforeMount, ref } from "vue";
import { useStore } from "@/store";

export default defineComponent({
  name: "AccountCard",
  components: {
    Card,
    BaseButton,
  },
  setup(props, { emit }) {
    const store = useStore();
    const formatMoney = (price: number) => {
      return Intl.NumberFormat("ru-RU", { style: "decimal" }).format(price);
    };
    const account = computed(() => store.getters.accountGet);

    const getTrans = () => store.dispatch("getTransactions");
    const getAccount = () => {
      store.dispatch("getAccount");
    };

    const showPaymentModal = () => {
      emit("showPaymentModal");
    };

    const onclickTrans = () => {
      emit("click-trans");
    };

    onBeforeMount(() => {
      getAccount();
      getTrans();
    });

    return {
      account,
      onclickTrans,
      formatMoney,
      showPaymentModal,
    };
  },
});
